export const TABLEE_MARKETING_BASE_URL = "https://www.tablee.cl/";

export const META_MARKETING_URL = `${TABLEE_MARKETING_BASE_URL}?utm_source=meta&utm_medium=paid_social&utm_campaign={{campaign.name}}&utm_content={{ad.name}}&utm_term={{adset.name}}&utm_id={{campaign.id}}&campaign_id={{campaign.id}}&adset_id={{adset.id}}&ad_id={{ad.id}}&placement={{placement}}&site_source={{site_source_name}}`;

const GOOGLE_MARKETING_SUFFIX = "utm_source=google&utm_medium=cpc&utm_campaign={campaignid}&utm_content={creative}&utm_term={keyword}&utm_id={campaignid}&campaign_id={campaignid}&adgroup_id={adgroupid}&ad_id={creative}&device={device}&network={network}&placement={placement}";

export const MARKETING_URL_TEMPLATES = [
  {
    id: "meta",
    title: "Meta Ads",
    icon: "campaign",
    helper: "Pegar como URL del sitio web del anuncio.",
    value: META_MARKETING_URL,
  },
  {
    id: "google-final-url",
    title: "Google Ads URL final",
    icon: "ads_click",
    helper: "Usar como URL final si quieres pegar la direccion completa.",
    value: `${TABLEE_MARKETING_BASE_URL}?${GOOGLE_MARKETING_SUFFIX}`,
  },
  {
    id: "google-final-url-suffix",
    title: "Google Ads sufijo",
    icon: "link",
    helper: "Pegar en Sufijo de URL final si ya tienes la URL final configurada.",
    value: GOOGLE_MARKETING_SUFFIX,
  },
];
